import React, { useRef, useState } from "react";
import { defineMessages, useIntl, FormattedMessage } from "react-intl";
import { Card, Form, CheckmarkButton } from "@lysaab/ui-2";
import onfidoLogo from "./onfido-logo.svg";
import "./OnfidoPoaIntroPage.scss";
import { Button } from "@lysaab/ui-2/components/buttons/Button";
import { sendResumeEmailPoa } from "../../data/onfido";
const messages = defineMessages({
    ingressMsg: { id: "onfido.poa.intro.ingress" },
    p1Msg: { id: "onfido.poa.intro.p1" },
});
export const OnfidoPoaIntroPage = ({ next, signupId, language, }) => {
    const formRef = useRef();
    const [success, setSuccess] = useState(false);
    const intl = useIntl();
    return (React.createElement("div", { className: "onfido-poa-intro-page" },
        React.createElement("h2", null,
            React.createElement(FormattedMessage, { id: "onfido.poa.intro.title" })),
        React.createElement(Card, null,
            React.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "center",
                    padding: "7px 0 4px 0",
                } },
                React.createElement("img", { src: onfidoLogo, className: "onfido-logo", alt: "Onfido logo" })),
            React.createElement("p", { style: { fontWeight: "bold" } }, intl.formatMessage(messages.ingressMsg)),
            React.createElement("p", null, intl.formatMessage(messages.p1Msg)),
            React.createElement("p", { className: "email-text" },
                React.createElement(FormattedMessage, { id: "onfido.poa.intro.email.text" })),
            React.createElement(Form, { lysaFormRef: formRef, onSubmit: (event) => {
                    var _a;
                    event.preventDefault();
                    if (((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.isValid) && language) {
                        sendResumeEmailPoa(signupId, language).then(() => {
                            setSuccess(true);
                            setTimeout(() => setSuccess(false), 2000);
                        });
                    }
                } },
                React.createElement(CheckmarkButton, { type: "submit", className: "button-secondary block", isSuccessful: success },
                    React.createElement(FormattedMessage, { id: "onfido.poa.intro.button.email" })))),
        React.createElement(Button, { type: "button", block: true, onClick: next, label: React.createElement(FormattedMessage, { id: "onfido.poa.intro.next" }) })));
};
